const SENTINEL_ACTIONS = {
    ENCRYPT: "ENCRYPT",
    MASK_COMPLETELY: "MASK_COMPLETELY",
    MASK_PARTIALLY: "MASK_PARTIALLY",
    CUSTOM_MASK: "CUSTOM_MASK",
    MASK_M_N: "MASK_M_N",
    MASK_BY_REGEX: "MASK_BY_REGEX",
    DO_NOTHING: "DO_NOTHING",
    NO_ACTION: "NO_ACTION"
};

type CommonPerformanceSettings = {
    readonly batchSize: string;
    readonly batchTimeout: string;
}

type OpenAIVertexAIPerformanceSettings = CommonPerformanceSettings & {
    readonly parallelRequestCount: string;
}

type StriimAIPerformanceSettings = CommonPerformanceSettings & {
    readonly striimAIMode: string;
}

const STRIIM_AI_DEFAULT_PERFORMANCE_SETTINGS: StriimAIPerformanceSettings = {
    batchSize: "128",
    batchTimeout: "5s",
    striimAIMode: "Basic"
};

//OpenAI/VertexAI
const DEFAULT_PERFORMANCE_SETTINGS: OpenAIVertexAIPerformanceSettings = {
    batchSize: "64",
    batchTimeout: "5s",
    parallelRequestCount: "16",
};


export { SENTINEL_ACTIONS, STRIIM_AI_DEFAULT_PERFORMANCE_SETTINGS, DEFAULT_PERFORMANCE_SETTINGS };
